export default __webpack_public_path__ + "static/media/PlanIt.afe09fd5.gif";